import firebase from "firebase/app";

export default class FirestoreService {

    static timestamp() {
        return firebase.firestore.FieldValue.serverTimestamp();
    }

    static firestoreDB() {
        const firestore = firebase.firestore();
        return firestore;
    }

    // Convert an array to an object with boolean value to allow filtering
    // See : https://firebase.google.com/docs/firestore/solutions/arrays
    static ArrayToObject(items) {
        if (typeof (items) === 'undefined') return null;
        const arrObj = {};
        items.forEach(function (item) {
            if (typeof (item) === 'string') {
                arrObj[item] = true;
            } else if (typeof (item) === 'object' && typeof (item.value) !== 'undefined') {
                arrObj[item.value] = true;
            } else {
                throw new Error("Object cannot be converted to object");
            }
        });
        return arrObj;
    }
    static ObjectToArray(item) {
        if (typeof (item) === 'undefined') return null;
        return Object.keys(item);
    }

    static once(collection, docKey, callback) {
        var db = FirestoreService.firestoreDB();
        var docRef = db.collection(collection).doc(docKey);
        docRef.get().then(function (doc) {
            if (doc.exists) {
                const data = doc.data();
                return callback(null, data);
            } else {
                return callback("no such doc");
            }
        });
    }

    static update(collection, docKey, newData) {
        if (!collection || !docKey || !newData) {
            return;
        }
        var db = FirestoreService.firestoreDB();
        var ref = db.collection(collection).doc(docKey);
        ref.set(newData, { merge: true });
    }

    static deleteQueryBatch(db, query, batchSize, resolve, reject) {
        query.get()
            .then((snapshot) => {
                // When there are no documents left, we are done
                if (snapshot.size === 0) {
                    return 0;
                }

                // Delete documents in a batch
                var batch = db.batch();
                snapshot.docs.forEach((doc) => {
                    batch.delete(doc.ref);
                });

                return batch.commit().then(() => {
                    return snapshot.size;
                });
            }).then((numDeleted) => {
                if (numDeleted === 0) {
                    resolve();
                    return;
                }

                // Recurse on the next process tick, to avoid
                // exploding the stack.
                process.nextTick(() => {
                    this.deleteQueryBatch(db, query, batchSize, resolve, reject);
                });
            })
            .catch(reject);
    }

    static deleteDocument(collection, docid, parentCollectionRef) {
        if (typeof (parentCollectionRef) !== 'undefined' && parentCollectionRef != null) {
            parentCollectionRef.collection(collection).doc(docid).delete();
        } else {
            FirestoreService.firestoreDB().collection(collection).doc(docid).delete();
        }
    }

}



// WEBPACK FOOTER //
// ./src/service/FirestoreService.js